import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { InputAdornment } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@material-ui/core/TextField";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import { getMsgShortLinks_Url } from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import Pagination from "../pagination/Pagination";
import "./ShortLinkList.css";
import _ from "lodash";
import PaginationRowAction from "../../../redux/paginationRow/PaginationRowAction";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";

class PaymentShortLinkDialog extends Component {
  header = store.getState().header.header;
  paginationState = store.getState().paginations.paymetShortLinkState;

  constructor(props) {
    super(props);

    if (this.paginationState) {
      this.paginationStateDetails = Object.getOwnPropertyNames(
        this.paginationState
      );
    }
    this.state = {
      messageId: "",
      messageName: "",
      shortUrl: "",
      shortlinkUrl: "",
      searchText: "",
      clickCount: 0,
      initialPage: 0,
      pageSize:
        this.paginationStateDetails?.length > 0
          ? this.paginationState?.pageSize
          : 10,
      sortColumn: this.paginationStateDetails?.length > 0
        ? this.paginationState?.sortColumn : null,
      isAscSort: this.paginationStateDetails?.length > 0
        ? this.paginationState?.isAscSort : false,
      sortDirection: "asc",
      msgShortLinkList: [],
      alertVisible: false,
      individualClicks: false,
      open: false,
    };
    this.debouncedSearch = _.debounce(this.showMsgShortLinkList, 800);
    this.debouncedSearch = _.debounce(this.showClickPaymentLinkList, 800);
  }

  showMsgShortLinkList(
    messageId,
    pageNo,
    pageSize,
    clickCount,
    sortBy,
    isAscSort
  ) {
    const postObject = {
      header: this.header,
      messageId: messageId,
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo,
        pageSize: pageSize,
        sortBy: sortBy,
        isAscSort: isAscSort,
      },
    };
    FetchServerData.callPostService(getMsgShortLinks_Url, postObject).then(
      (output) => {
        if (Utils.equalsIgnoreCase(output.status, "SUCCESS")) {
          let msgShortLinkList = output.data.shortLinkList;
          let page = output.data.page;
          let isPaging = false;
          if (msgShortLinkList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < msgShortLinkList.length; i++) {
            msgShortLinkList[i].createdon = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventLocalTime(msgShortLinkList[i].createdon) : Utils.getUtcToLocal(
              msgShortLinkList[i].createdon
            );
          }
          this.setState({
            open: true,
            individualClicks: false,
            isPaging: isPaging,
            messageId: messageId,
            pageNo: page.pageNo,
            showPerPage: page.pageSize,
            totalPages: page.totalPages,
            totalRecords: page.total,
            msgShortLinkList: msgShortLinkList,
            clickCount: clickCount,
          });
        } else {
        }
      }
    );
  }
  showClickPaymentLinkList(
    messageId,
    pageNo,
    pageSize,
    clickCount,
    sortBy,
    isAscSort
  ) {
    const postObject = {
      header: this.header,
      messageId: messageId,
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo,
        pageSize: pageSize,
        sortBy: sortBy,
        isAscSort: isAscSort,
      },
    };
    FetchServerData.callPostService(
      "/su/getClickedPaymentLinks",
      postObject
    ).then((output) => {
      if (Utils.equalsIgnoreCase(output.status, "SUCCESS")) {
        let msgShortLinkList = output.data.shortLinkList;
        let page = output.data.page;
        let isPaging = false;
        if (msgShortLinkList.length > this.state.pageSize) {
          isPaging = true;
        }
        for (let i = 0; i < msgShortLinkList.length; i++) {
          msgShortLinkList[i].createdon = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventLocalTime(msgShortLinkList[i].createdon) : Utils.getUtcToLocal(
            msgShortLinkList[i].createdon
          );
        }
        this.setState({
          open: true,
          individualClicks: true,
          isPaging: isPaging,
          messageId: messageId,
          pageNo: page.pageNo,
          showPerPage: page.pageSize,
          totalPages: page.totalPages,
          totalRecords: page.total,
          msgShortLinkList: msgShortLinkList,
          clickCount: clickCount,
        });
      } else {
      }
    });
  }

  handleClose() {
    this.setState({ open: false });
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(this.state.messageId, 0, this.state.pageSize);
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    const paymetShortLinkState = {
      pageSize: pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(
      PaginationRowAction.paymentShortLinkPaginationState({ paymetShortLinkState })
    );
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.showMsgShortLinkList(
      this.state.messageId,
      currentPageIndex,
      pageSize,
      this.state.clickCount
    );
    this.setState({
      pageNo: currentPageIndex,
      pageSize: pageSize,
    });
  }

  handleSort(column) {
    const {
      sortColumn,
      sortDirection,
      messageId,
      pageNo,
      pageSize,
      clickCount,
      individualClicks,
    } = this.state;
    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";

    const isAscSort = newDirection === "asc";
    const paymetShortLinkState = {
      pageSize: pageSize,
      sortColumn: column,
      isAscSort: isAscSort,
    };
    store.dispatch(
      PaginationRowAction.paymentShortLinkPaginationState({ paymetShortLinkState })
    );
    this.setState(
      {
        sortColumn: column,
        sortDirection: newDirection,
      },
      () => {
        if (individualClicks) {
          this.showClickPaymentLinkList(
            messageId,
            pageNo,
            pageSize,
            clickCount,
            column,
            isAscSort
          );
        } else {
          this.showMsgShortLinkList(
            messageId,
            pageNo,
            pageSize,
            clickCount,
            column,
            isAscSort
          );
        }
      }
    );
  }

  render() {
    return (
      <Dialog
        open={this.state.open}
        onClose={this.handleClose.bind(this)}
        maxWidth="xl"
      >
        <DialogTitle id="scroll-dialog-title">
          <span style={{ color: "#fff" }}>Payment Short Link</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={this.handleClose.bind(this)}
          style={{
            position: "absolute",
            right: 8,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
        </IconButton>
        <DialogContent style={{ padding: "0px 24px 24px 24px" }}>
          <div
            md={12}
            className="tableContact"
            style={{
              width: "800px",
              color: "#000",
              fontSize: "small",
            }}
          >
            <div className="row mt-4">
              <div className="col">
                <div className="col md-12">
                  <div className="card rounded-0">
                    <div
                      className="row justify-content-between"
                      style={{ padding: "0.6em 1.2rem" }}
                    >
                      <div className="d-flex col-12 col-lg-5 col-xl-5">
                        <div className="col-12 text-start totalResults align-self-center">
                          <span>
                            {this.state.individualClicks
                              ? "Individual clicks"
                              : "Total clicks"}
                            : {this.state.clickCount}
                          </span>
                        </div>
                      </div>
                      <div className="d-flex col-12 col-lg-7 col-xl-7 justify-content-end">
                        <TextField
                          id="standard-search"
                          placeholder="Search"
                          type="text"
                          variant="standard"
                          value={this.state.searchText}
                          onChange={this.onSearchChange.bind(this)}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <IconButton
                                  onClick={this.showMsgShortLinkList.bind(
                                    this,
                                    this.state.messageId,
                                    0,
                                    this.state.pageSize,
                                    this.state.clickCount
                                  )}
                                >
                                  <SearchIcon />
                                </IconButton>
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={() => {
                                    this.setState({ searchText: "" }, () => {
                                      this.showMsgShortLinkList(
                                        this.state.messageId,
                                        0,
                                        this.state.pageSize,
                                        this.state.clickCount
                                      );
                                    });
                                  }}
                                  disabled={!this.state.searchText}
                                >
                                  <ClearIcon
                                    style={{
                                      opacity: this.state.searchText ? 1 : 0.4,
                                      fontSize: "1.25rem",
                                      color: "353538",
                                    }}
                                  />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>
                    </div>
                    <div className="table-responsive paginationTable">
                      <table className="table text-start table-hover">
                        <thead className="paginationTableThead">
                          <tr>
                            <th className="col fw-bold">Mobile</th>
                            <th
                              className="col fw-bold"
                              onClick={() => this.handleSort("contactName")}
                            >
                              Name
                              {this.state.sortColumn === "contactName" &&
                                (this.state.sortDirection === "asc" ? (
                                  <i
                                    class="fa fa-long-arrow-up ps-1"
                                    aria-hidden="true"
                                  ></i>
                                ) : (
                                  <i class="fa-solid fa-arrow-down-long ps-1"></i>
                                ))}
                            </th>
                            <th
                              className="col fw-bold"
                              onClick={() => this.handleSort("createdon")}
                            >
                              Link clicked on
                              {this.state.sortColumn === "createdon" &&
                                (this.state.sortDirection === "asc" ? (
                                  <i
                                    class="fa fa-long-arrow-up ps-1"
                                    aria-hidden="true"
                                  ></i>
                                ) : (
                                  <i class="fa-solid fa-arrow-down-long ps-1"></i>
                                ))}{" "}
                            </th>
                            <th className="col fw-bold">Payment Link</th>
                            {!this.state.individualClicks && (
                              <th
                                className="col fw-bold"
                                onClick={() => this.handleSort("count")}
                              >
                                # Of Clicks
                                {this.state.sortColumn === "count" &&
                                  (this.state.sortDirection === "asc" ? (
                                    <i
                                      class="fa fa-long-arrow-up ps-1"
                                      aria-hidden="true"
                                    ></i>
                                  ) : (
                                    <i class="fa-solid fa-arrow-down-long ps-1"></i>
                                  ))}
                              </th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.msgShortLinkList?.map(
                            (rowData, index) => (
                              <tr
                                key={index}
                              // style={{
                              //   backgroundColor:
                              //     rowData.id === this.state.messageId
                              //       ? "#e6effc"
                              //       : "",
                              // }}
                              >
                                <td style={{ width: "180px" }}>
                                  {rowData.contactMobile}
                                </td>
                                <td style={{ width: "180px" }}>
                                  {rowData.contactName}
                                </td>
                                <td style={{ width: "220px" }}>
                                  {rowData.createdon}
                                </td>
                                <td style={{ width: "320px" }}>
                                  <a
                                    href={rowData.targetLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="anchortag fw-bold"
                                  >
                                    {Utils.truncateString(
                                      rowData.targetLink,
                                      50
                                    )}
                                  </a>
                                </td>
                                {!this.state.individualClicks && (
                                  <td style={{ width: "160px" }}>
                                    {rowData.count}
                                  </td>
                                )}
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                    {this.state.totalRecords === 0 && (
                      <div
                        className="row text-center"
                        style={{ padding: "6px 20px" }}
                      >
                        <h5 className="dataNotAvailable">No data found.</h5>
                      </div>
                    )}
                    {this.state.totalRecords > 10 && (
                      <div className="row justify-content-between pagination p-1">
                        <div className="d-flex col-12 col-lg-4 col-xl-4">
                          <div className="pageSize col-12 text-start">
                            Page {this.state.pageNo + 1} of{" "}
                            {this.state.totalPages}
                          </div>
                        </div>
                        <div className="d-flex col-12 col-lg-8 col-xl-8">
                          <div className="col-12 text-end">
                            <Pagination
                              showPerPage={this.state.showPerPage}
                              pageNo={this.state.pageNo}
                              onPaginationChange={this.onPaginationChange.bind(
                                this
                              )}
                              total={this.state.totalRecords}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}
export default PaymentShortLinkDialog;
